import React, {Component} from 'react';
import {get as _get, uniqueId} from 'lodash';
import {getChatObjects} from "../../util/broadcast/start_broadcast";
import {isEmpty, LogException} from "../../util/utility";
import {getData, LOGIN} from "../../util/storage";

export default class CheckBox extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loggedIn: false
        };
        //all the functions used in this component should be listed here for better documentation
        this.sendChat = this.sendChat.bind(this);
        this._handleKeyPress = this._handleKeyPress.bind(this);
    }

    componentDidMount() {
        getData(LOGIN)
            .then((data) => {
                this.setState({
                    loggedIn: (!isEmpty(data)) && data.api_token
                })
            })
    }

    showLogin = ()=>{
        this.props.history.push(
            {
                pathname: '/login',
                state: {
                    basePath: this.props.history.location.pathname,
                    search: _get(this.props, 'history.location.search', '')
                }
            }
        );
    };

    sendIfLoggedIn = () => {
        if (this.props.userType === "Viewer") {
            if (this.state.loggedIn) {
                this.sendChat()
            } else {
                this.showLogin()
            }
        } else {
            this.sendChat();
        }
    };

    sendChat = () => {
        const input = document.getElementById("chat-input-text").value.trim();
        if (input.length >= 1) {
            document.getElementById("chat-input-text").value = "";
            this.props.session.signal({
                    data: input,
                    type: this.props.userType
                }, (error) => {
                    if (error) {
                        LogException("StartBroadcast", "sendChat", error);
                    } else {
                        var elmnt = document.getElementById("divElem");
                        elmnt.scrollTop = elmnt.scrollHeight + 36;
                    }
                }
            );
        }
    }

    _handleKeyPress = (e) => {
        if (this.props.userType === "Viewer") {
            if (this.state.loggedIn) {
                if (e.key === 'Enter') {
                    if (e.target.value.trim().length >= 1) {
                        this.sendChat();
                    }
                }
            } else {
                e.preventDefault();
                this.showLogin();
            }
        } else {
            if (e.key === 'Enter') {
                if (e.target.value.trim().length >= 1) {
                    this.sendChat();
                }
            }

        }
    }

    _handleUserNameClickEvent = (connection) => {
        //user_api_id username
        if (connection.hasOwnProperty("userData") &&
            connection.userData.hasOwnProperty("user_api_id") &&
            connection.userData.hasOwnProperty("username") &&
            connection.userData.username !== connection.userData.user_api_id &&
            connection.userData.username !== "guest") {

            this.props.setUserData(connection);
            this.props.toggleInviteForSessionModal()
        }

    }

    render() {
        return (
            <div className="col-xl-4 col-lg-12">
                <div className="h-100">
                    <div className="chat-container">
                        <div className="chat-wrapper">
                            <div className="input-group">
                                <input type="text"
                                       className="form-control"
                                       id="chat-input-text"
                                       placeholder="Chat here..."
                                       onKeyPress={this._handleKeyPress}/>
                                <div className="input-group-append">
                                    <button className="btn btn-primary"
                                            type="button"
                                            onClick={this.sendIfLoggedIn}>Send
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div id="divElem" className="chats">
                            <div style={{
                                position: "absolute",
                                bottom: 0,
                                height: '100%',
                                width: 'calc(100% - 30px)'
                            }}>
                                {
                                    getChatObjects(this._handleUserNameClickEvent, this.props.signalArray, this.props.actionsAllowed)
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}